import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CashFlowListComponent } from './components/cash-flow-list/cash-flow-list.component';
import {CashFlowsRoutingModule} from "./cash-flows-routing.module";
import {TandemCoreModule} from "../tandem-core/tandem-core.module";
import {ReactiveFormsModule} from "@angular/forms";
import { CashFlowFormComponent } from './components/cash-flow-form/cash-flow-form.component';
import { CreateCashFlowComponent } from './components/create-cash-flow/create-cash-flow.component';
import { EditCashFlowComponent } from './components/edit-cash-flow/edit-cash-flow.component';
import { ViewCashFlowComponent } from './components/view-cash-flow/view-cash-flow.component';
import { CashFlowGraphComponent } from './components/cash-flow-graph/cash-flow-graph.component';
import {NgxEchartsModule} from "ngx-echarts";
import { CsvMappingComponent } from './components/csv-mapping/csv-mapping.component';
import { DateValidationDialogComponent } from './components/date-validation-dialog/date-validation-dialog.component';
import {FinancialPositionsModule} from "../financial-positions/financial-positions.module";
import {TandemDatePipe} from "../tandem-core/directives/tandem-date.pipe";



@NgModule({
    declarations: [
        CashFlowListComponent,
        CashFlowFormComponent,
        CreateCashFlowComponent,
        EditCashFlowComponent,
        ViewCashFlowComponent,
        CashFlowGraphComponent,
        CsvMappingComponent,
        DateValidationDialogComponent
    ],
    exports: [
        CashFlowGraphComponent,
      CashFlowListComponent
    ],
  imports: [
    CommonModule,
    CashFlowsRoutingModule,
    TandemCoreModule,
    ReactiveFormsModule,
    NgxEchartsModule,
    FinancialPositionsModule
  ],
  providers: [
    TandemDatePipe
  ]
})
export class CashFlowsModule { }
